import React from "react";
import { cn } from "@/lib/utils";

type TooltipProps = {
  content?: string;
  children: React.ReactNode;
  className?: string;
};

export const Tooltip = ({ content, children, className }: TooltipProps) => {
  if (!content) return <>{children}</>;

  return (
    <span className={cn("relative inline-flex group", className)}>
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 -top-8 -translate-x-1/2 whitespace-nowrap rounded-md bg-black px-2 py-1 text-[11px] text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {content}
      </span>
    </span>
  );
};
